// Mount point for Quote tools, today's Offer tools (#36367).
const QuoteTools = () => null;

export default QuoteTools;
